import { STAGES } from "@/lib/constants";

// Central stage & status visual mapping
const stageStyles = {
  "MG1":       "bg-[#F4EFE1] text-[#6B5A1D] border-[#E4D8B0]",
  "MG2/BP1":   "bg-[#EEF1F7] text-[#243B6E] border-[#C6D1E6]",
  "FP1":       "bg-[#EEF1F7] text-[#243B6E] border-[#C6D1E6]",
  "BP2":       "bg-[#EEF1F7] text-[#243B6E] border-[#C6D1E6]",
  "FP2":       "bg-[#EEF1F7] text-[#243B6E] border-[#C6D1E6]",
  "PreL":      "bg-[#FBF3DC] text-[#7A5A0C] border-[#EDD98C]",
  "Launch":    "bg-[#EAF6EE] text-[#1F5D34] border-[#B7DFC4]",
  "Post Launch":"bg-[#EAF6EE] text-[#1F5D34] border-[#B7DFC4]",
};

export function StageBadge({ stage }) {
  const cls = stageStyles[stage] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`stage-badge-${stage}`}
      className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full border ${cls}`}
    >
      {stage}
    </span>
  );
}

const statusStyles = {
  "Active":     "bg-[#EEF1F7] text-[#0A1F44] border-[#C6D1E6]",
  "Launched":   "bg-[#EAF6EE] text-[#1F5D34] border-[#B7DFC4]",
  "Dropped Out":"bg-[#FBECEC] text-[#8A1F1F] border-[#EFC0C0]",
};

export function StatusBadge({ status }) {
  const cls = statusStyles[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center text-xs font-semibold px-2 py-0.5 rounded-full border ${cls}`}
    >
      {status}
    </span>
  );
}

export { STAGES };
